import { createReducer, on } from '@ngrx/store';
import * as ServiceslistActions from './Serviceslist.action';

export interface ServiceslistState {
  services: any[];
  loading: boolean;
  error: string | null;
}

export const initialState: ServiceslistState = {
  services: [],
  loading: false,
  error: null,
};

export const serviceslistReducer = createReducer(
  initialState,
  on(ServiceslistActions.loadServices, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ServiceslistActions.loadServicesSuccess, (state, { services }) => ({
    ...state,
    services,
    loading: false,
  })),
  on(ServiceslistActions.loadServicesFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
  }))
);
